import type { RenewalForecast, RenewalForecastContract, RenewalForecastPeriod } from '@/types';

/** A forecast contract together with the period it was grouped into */
export interface RenewalForecastRow extends RenewalForecastContract {
  periodKey: string;
  periodLabel: string;
}

/** Flattens a period's contracts into rows that remember their period. */
export function rowsOfPeriod(period: RenewalForecastPeriod): RenewalForecastRow[] {
  return period.contracts.map((contract) => ({ ...contract, periodKey: period.key, periodLabel: period.label }));
}

/** Every contract in the forecast, in period order. */
export function rowsOfForecast(forecast: RenewalForecast): RenewalForecastRow[] {
  return forecast.periods.flatMap(rowsOfPeriod);
}
